import React, { useRef } from "react";
import Topbar from "../Topbar/Topbar";
import { Container, Row, Col } from "react-bootstrap";
import { useState } from "react";
import { MdDelete } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import "./Complaint.css";
import { useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import Map from "../images/mapicon.svg";
import { useDownloadExcel } from "react-export-table-to-excel";

export default function Complaint() {
  const [complaintdata, setcomplaintdata] = useState([]);
  const [complaintDelete, setComplaintDelete] = useState("");
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
     const designation = useSelector((state) => state.designation);
  const permissions = useSelector((state) => state.permissions);
  let [dataCount, setDataCount] = useState([]);
  //setting popup
  const [complaintSetting, setComplaintSetting] = useState(false);
  const complaintSettingPopup = (e) => {
    e.preventDefault();
    setComplaintSetting(!complaintSetting);
  };

  const [columnVisibility, setColumnVisibility] = useState({
    ComplaintID: true,
    ComplaintStatus: true,
    ComplaintStartDate: true,
    CustomerAffected: true,
    ContactNumber: true,
    Address: true,
    Location: true,
    Notes: true,
    WorkAssign: true,
    WorkStatus: true,
    Feedback: true,
    AdditionalCharge: true,
    Payment: true,
    delete: true,
  });

  const handleColumnVisibilityChange = (e) => {
    const { name, checked } = e.target;
    setColumnVisibility((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  let changedata = (data) => {
    if (data === "ComplaintID") {
      return "  Complaint ID";
    }
    if (data === "ComplaintStatus") {
      return "Complaint Status";
    }
    if (data === "ComplaintStartDate") {
      return "Complaint Start Date";
    }
    if (data === "CustomerAffected") {
      return "Customer Affected";
    }
    if (data === "ContactNumber") {
      return "Contact Number";
    }
    if (data === "Address") {
      return "Address";
    }

    if (data === "Location") {
      return "Location";
    }

    if (data === "Notes") {
      return "Notes";
    }

    if (data === "WorkAssign") {
      return "WorkAssign";
    }

    if (data === "WorkStatus") {
      return " WorkStatus";
    }

    if (data === "Feedback") {
      return "Feedback";
    }
    if (data === "AdditionalCharge") {
      return "Additional Charge";
    }
    if (data === "Payment") {
      return "Payment";
    }

    if (data === "delete") {
      return "Delete";
    } else {
      return data;
    }
  };
  //end

  const navigate = useNavigate();

  const getLeadStatusColor = (status) => {
    if (!status) return "";
    switch (status.toLowerCase().trim()) {
      case "completed":
        return "status-converted";
      case "paid":
        return "status-converted";
      case "verified":
        return "status-converted";
      case "assigned":
        return "status-converted";
      case "progress":
        return "status-progress";

      case "open":
        return "status-open";
      default:
        return "";
    }
  };

  const [filters, setFilters] = useState({
    ComplaintID: "",
    ComplaintStatus: "",
    ComplaintStartDate: "",
    CustomerAffected: "",
    ContactNumber: "",
    Address: "",
    Location: "",
    Notes: "",
    WorkAssign: "",
    WorkStatus: "",
    Feedback: "",
    AdditionalCharge: "",
    Payment: "",
    delete: "",
  });

  const getTabStatusColor = (status) => {
    if (!status) return "";
    switch (status.toLowerCase().trim()) {
      case "completed":
        return "status-converted";
             case "assigned":
        return "status-converted";
             case "paid":
        return "status-converted";
      case "pending":
        return "status-pending";

      default:
        return "";
    }
  };
  const gotoviewcomplaints = (id) => {
    navigate("/view_complaint", {
      state: { id: id },
    });
  };

  useEffect(() => {
    axios.get(apiUrl + "complaint-stats", {}).then((res) => {
      const add_installation = res.data.stats || [];
      setDataCount(add_installation);
    });
  }, []);

  const gotoAddComplaints = (e) => {
    e.preventDefault();
    navigate("/add_complaint");
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value.toLowerCase(), // Normalize input for case-insensitive search
    }));
  };

  const fiterSetting = complaintdata?.filter((complaint) => {
    return Object.keys(filters).every((key) => {
      const filterValue = filters[key]?.toString().toLowerCase().trim();
      if (!filterValue) return true;

      try {
        switch (key) {
          case "ComplaintID":
            return (complaint.leadId || "")
              .toString()
              .toLowerCase()
              .includes(filterValue);

          case "ComplaintStatus":
            return (complaint.leadStatus || "")
              .toString()
              .toLowerCase()
              .includes(filterValue);

          case "ComplaintStartDate":
            const formattedDate = formatDate(complaint.createdDate || "");
            return formattedDate.toLowerCase().includes(filterValue);

          case "CustomerAffected":
            return (complaint.complaintcustomerAffected || "")
              .toString()
              .toLowerCase()
              .includes(filterValue);

          case "ContactNumber":
            return (complaint.complaintcontactNum || "")
              .toString()
              .toLowerCase()
              .includes(filterValue);

          case "Address":
            return (complaint.complaintaddress || "")
              .toString()
              .toLowerCase()
              .includes(filterValue);

          case "Location":
            const locationStr = complaint.location?.latitude
              ? `${complaint.location.latitude}, ${complaint.location.longitude}`
              : "N/A";
            return locationStr.toLowerCase().includes(filterValue);

          case "Notes":
            return (complaint.complaintleadStatus?.complaintnotes || "")
              .toString()
              .toLowerCase()
              .includes(filterValue);

          case "WorkAssign":
            const workAssignStatus =
              complaint.workAssign?.fiberTeam?.fiberTeamAssigned &&
              complaint.workAssign?.networkTeam?.networkTeamAssigned
                ? "Assigned"
                : "Pending";
            return workAssignStatus.toLowerCase().includes(filterValue);

          case "WorkStatus":
            const workStatus = complaint.workAssign?.isCompleted
              ? "Completed"
              : "Pending";
            return workStatus.toLowerCase().includes(filterValue);

          case "Feedback":
            const feedbackStatus = complaint.feedback?.isCompleted
              ? "Completed"
              : "Pending";
            return feedbackStatus.toLowerCase().includes(filterValue);

          case "AdditionalCharge":
            return (complaint.complaintadditionalCharges || "")
              .toString()
              .toLowerCase()
              .includes(filterValue);

          case "Payment":
            if (!complaint.complaintadditionalCharges)
              return filterValue === "-";
            const paymentStatus = complaint.payment?.isCompleted
              ? "Paid"
              : "Pending";
            return paymentStatus.toLowerCase().includes(filterValue);

          default:
            return true;
        }
      } catch (error) {
        console.error(`Error filtering by ${key}:`, error);
        return true;
      }
    });
  });

  const formatDate = (date) => {
    return dayjs(date).format("DD-MM-YYYY");
  };

  const handleDelete = async (leadId) => {
    // Show confirmation popup
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "you want to delete this data!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        // API Call to delete user
        await axios.post(apiUrl + "delete-complaint", {
          leadId: leadId,
        });

        // Success message
        Swal.fire("Deleted!", "Your data has been deleted.", "success");
        setComplaintDelete(true);

        // if (onDeleteSuccess) {
        //   onDeleteSuccess();
        // }
      } catch (error) {
        // Error handling
        Swal.fire("Error!", "Something went wrong while deleting.", "error");
        console.error("Delete Error:", error);
      }
    }
  };

  useEffect(() => {
    axios.post(apiUrl + "view-complaint", {}).then((res) => {
      const add_installation = res.data.message || [];
      setcomplaintdata(add_installation);

      // const counts = {
      //   active: customers.filter((c) => c.accountstatus === "Active").length,
      //   inactive: customers.filter((c) => c.accountstatus === "Inactive")
      //     .length,
      //   suspended: customers.filter((c) => c.accountstatus === "Suspended")
      //     .length,
      //   disabled: customers.filter((c) => c.accountstatus === "Disable").length,
      //   online: customers.filter((c) => c.devicestatus === "Online").length,
      //   offline: customers.filter((c) => c.devicestatus === "Offline").length,
      // };
      // setStatusCounts(counts);
    });
  }, [complaintDelete]);
  const handleMapClick = () => {
    navigate("/taskmapview?page=complaint");
  };

  useEffect(() => {
    axios.post(apiUrl + "view-complaint", {}).then((res) => {
      const add_installation = res.data.message || [];
      setcomplaintdata(add_installation);

      // const counts = {
      //   active: customers.filter((c) => c.accountstatus === "Active").length,
      //   inactive: customers.filter((c) => c.accountstatus === "Inactive")
      //     .length,
      //   suspended: customers.filter((c) => c.accountstatus === "Suspended")
      //     .length,
      //   disabled: customers.filter((c) => c.accountstatus === "Disable").length,
      //   online: customers.filter((c) => c.devicestatus === "Online").length,
      //   offline: customers.filter((c) => c.devicestatus === "Offline").length,
      // };
      // setStatusCounts(counts);
    });
  }, [complaintDelete]);
  useEffect(() => {
    console.log("Current filters:", filters);
  }, [filters]);

//Export PopUp
 const tableRef = useRef(null);
 const {onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Compalint_data",
    sheet: "Complaint",
  });
  const [shouldExport, setShouldExport] = useState(false);
  
    const handleExportConfirmation = () => {
      Swal.fire({
        title: "Are you sure?",
        text: "Do you want to export the Compalint details?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, export it!",
        cancelButtonText: "No, cancel",
      }).then((result) => {
        if (result.isConfirmed) {
          onDownload();
          setShouldExport(true); // Allow the export to proceed
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire("Cancelled", "The export operation was cancelled.", "error");
          setShouldExport(false);
        }
      });
    };
  return (
    <div>
      <Topbar />
      <Container fluid className=" pt-1 customer-row ">
        <h3 className=" px-2  ">Complaint</h3>

        {permissions?.Complaint?.["Complaint Statistics"]?.Read && (
          <Row className=" row-width">
            <Col className="dashborder mt-4 mb-5 mx-2">
              <Row className="yellow-card">
                <p
                  className="text-center box-txt "
                  style={{ marginTop: "8px" }}
                >
                  Open
                </p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">{dataCount.open}</h5>
              </Row>
            </Col>
            <Col className="dashborder mt-4 mb-5 mx-1">
              <Row className="purple-card">
                <p className="text-center pt-3 box-txt">Field Team Working</p>
              </Row>
              <Row className="number">
                {/* <h5 className="text-center">{dataCount.fieldTeamWorking}</h5> */}
                <h5 className="text-center">0</h5>
              </Row>
            </Col>
            <Col className="dashborder mt-4 mb-5  mx-1">
              <Row className="orange-card ">
                <p className="text-center pt-1 box-txt">Network Team Working</p>
              </Row>
              <Row className="number">
                {/* <h5 className="text-center pt-1">{dataCount.networkTeamWorking}</h5> */}
                <h5 className="text-center">0</h5>
              </Row>
            </Col>
            <Col className="dashborder mt-4 mb-5 mx-1">
              <Row className="grey-card row-margin">
                <p className="text-center pt-1 box-txt">Progress</p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">{dataCount.pending}</h5>
              </Row>
            </Col>
            <Col className="dashborder mt-4 mb-5 mx-1">
              <Row className="green-card">
                <p className="text-center pt-1 box-txt">Completed</p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">{dataCount.completed}</h5>
              </Row>
            </Col>
          </Row>
        )}

        <Row className=" button-bottom-custmer" xs={1} sm={2}>
          <Col className="mt-2 mb-2" md={5}>
            {permissions?.Complaint?.["Add Complaint"]?.Write && (
              <button
                onClick={gotoAddComplaints}
                className="black-btn btnadd  black-btn1"
              >
                Add
              </button>
            )}{" "}
            &emsp;&emsp;
            <button
              onClick={() => window.location.reload()}
              className="black-btn black-btn1"
            >
              Refresh
            </button>
          </Col>

          <Col className="mt-2 text-end" md={6}>
               {/* <button
  className="black-btn black-btn1 btnadd"
  onClick={
    designation === "Super Admin" && fiterSetting.length > 0
      ? handleExportConfirmation
      : undefined
  }
  disabled={designation !== "Super Admin" || fiterSetting.length === 0}
  style={{
    opacity:
      designation === "Super Admin" && fiterSetting.length > 0 ,
    cursor:
      designation === "Super Admin" && fiterSetting.length > 0
        ? "pointer"
        : "not-allowed",
  }}
  title={
    designation !== "Super Admin"
      ? "Only Super Admin can export"
      : fiterSetting.length === 0
      ? "No data to export"
      : "Export"
  }
>
  Export
          </button> */}
            &emsp;&emsp;
            <button
              className="black-btn black-btn1 "
              onClick={complaintSettingPopup}
            >
              Settings
            </button>
            {complaintSetting && (
              <div className="setting-popup-overlay">
                <div className="setting-popup-container">
                  <button
                    className="setting-close-btn"
                    onClick={complaintSettingPopup}
                  >
                    &times;
                  </button>
                  <div className="setting-popup-content">
                    <div className="setting-checkbox-row">
                      <label>
                        <input
                          className="checkbox-customer"
                          type="checkbox"
                          checked={Object.values(columnVisibility).every(
                            (v) => v
                          )}
                          onChange={(e) => {
                            const isChecked = e.target.checked;
                            setColumnVisibility(
                              Object.keys(columnVisibility).reduce(
                                (acc, key) => {
                                  acc[key] = isChecked;
                                  return acc;
                                },
                                {}
                              )
                            );
                          }}
                        />
                        <span
                          className="checkbox-down ms-1"
                          style={{ fontSize: "17px" }}
                        >
                          {Object.values(columnVisibility).every((v) => v)
                            ? "Unselect All"
                            : "Select All"}
                        </span>
                      </label>
                    </div>

                    <div className="setting-checkbox-grid">
                      {Object.keys(columnVisibility).map((key) => (
                        <label key={key} className="label-setting-popup">
                          <input
                            type="checkbox"
                            name={key}
                            checked={columnVisibility[key]}
                            onChange={handleColumnVisibilityChange}
                            className="checbox-popup"
                          />
                          <span className="checkbox-down1">
                            {changedata(key)}
                          </span>
                        </label>
                      ))}
                    </div>

                    <button
                      className="setting-submit-btn"
                      onClick={complaintSettingPopup}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            )}
          </Col>
          <Col md={1}>
            <img
              src={Map}
              alt="map"
              style={{ width: "30px", height: "30px" }}
              className="map-icon text-end"
              onClick={handleMapClick}
            />
          </Col>
        </Row>

        <br />

        <div className="scrolltable">
          <table className="table table-bordered" ref={tableRef}>
            <thead className="table-th text-center">
              {columnVisibility.ComplaintID && (
                <th className="table-th-content ">Complaint ID</th>
              )}
              {columnVisibility.ComplaintStatus && (
                <th className="table-th-content">Complaint Status</th>
              )}
              {columnVisibility.ComplaintStartDate && (
                <th className="table-th-content">Complaint Start Date</th>
              )}
              {columnVisibility.CustomerAffected && (
                <th className="table-th-content">Customer Affected</th>
              )}
              {columnVisibility.ContactNumber && (
                <th className="table-th-content">Contact Number</th>
              )}
              {columnVisibility.Address && (
                <th className="table-th-content">Address</th>
              )}
              {columnVisibility.Location && (
                <th className="table-th-content">Location</th>
              )}
              {columnVisibility.Notes && (
                <th className="table-th-content">Notes</th>
              )}
              {/* <th className="table-th-content">Verification Status</th> */}
              {columnVisibility.WorkAssign && (
                <th className="table-th-content">Work Assign</th>
              )}
              {columnVisibility.WorkStatus && (
                <th className="table-th-content">Work Status</th>
              )}
              {columnVisibility.Feedback && (
                <th className="table-th-content">Feedback</th>
              )}
              {columnVisibility.AdditionalCharge && (
                <th className="table-th-content">Additional Charge</th>
              )}
              {columnVisibility.Payment && (
                <th className="table-th-content">Payment</th>
              )}
              {columnVisibility.delete && (
                <th className="table-th-content ">Delete</th>
              )}
            </thead>

            <tbody className="tr:nth-child(even)">
              <tr>
                {columnVisibility.ComplaintID && (
                  <td>
                    <input
                      className="table-search background-change"
                      name="ComplaintID"
                      onChange={handleFilterChange}
                      placeholder="Search"
                    />
                  </td>
                )}
                {columnVisibility.ComplaintStatus && (
                  <td>
                    <select
                      className="table-search background-change"
                      name="ComplaintStatus"
                      onChange={handleFilterChange}
                    >
                      <option value="">All</option>
                      <option value="Open">Open</option>
                      <option value="Update">Update</option>
                      <option value="Hold">Hold</option>
                      <option value="Not Interested">Not Interested</option>
                      <option value="Converted">Converted</option>
                      <option value="Not Feasible">Not Feasible</option>
                      <option value="Cancelled">Cancelled</option>
                    </select>
                  </td>
                )}
                {columnVisibility.ComplaintStartDate && (
                  <td>
                    <input
                      className="table-search background-change"
                      type="date"
                      name="ComplaintStartDate"
                      onChange={handleFilterChange}
                    />
                  </td>
                )}
                {columnVisibility.CustomerAffected && (
                  <td>
                    <input
                      className="table-search background-change"
                      name="CustomerAffected"
                      onChange={handleFilterChange}
                      placeholder="Search"
                    />
                  </td>
                )}
                {columnVisibility.ContactNumber && (
                  <td>
                    <input
                      className="table-search background-change"
                      name="ContactNumber"
                      type="tel"
                      onChange={handleFilterChange}
                      onKeyDown={(e) => {
                        if (
                          ["e", "E", "+", "-"].includes(e.key) ||
                          (e.key &&
                            !/[0-9]/.test(e.key) &&
                            e.key !== "Backspace" &&
                            e.key !== "ArrowLeft" &&
                            e.key !== "ArrowRight")
                        ) {
                          e.preventDefault();
                        }
                      }}
                      placeholder="Search"
                    />
                  </td>
                )}
                {columnVisibility.Address && (
                  <td>
                    <input
                      className="table-search background-change"
                      name="Address"
                      onChange={handleFilterChange}
                      placeholder="Search"
                    />
                  </td>
                )}
                {columnVisibility.Location && (
                  <td>
                    <input
                      className="table-search background-change"
                      name="Location"
                      onChange={handleFilterChange}
                      placeholder="Search"
                    />
                  </td>
                )}
                {columnVisibility.Notes && (
                  <td>
                    <input
                      className="table-search background-change"
                      name="Notes"
                      onChange={handleFilterChange}
                      placeholder="Search"
                    />
                  </td>
                )}
                {columnVisibility.WorkAssign && (
                  <td>
                    <select
                      className="table-search background-change"
                      name="WorkAssign"
                      onChange={handleFilterChange}
                    >
                      <option value="">All</option>
                      <option value="Pending">Pending</option>
                      <option value="Progress">Progress</option>
                      <option value="Completed">Completed</option>
                      <option value="Cancelled">Cancelled</option>
                    </select>
                  </td>
                )}
                {columnVisibility.WorkStatus && (
                  <td>
                    <select
                      className="table-search background-change"
                      name="WorkStatus"
                      onChange={handleFilterChange}
                    >
                      <option value="">All</option>
                      <option value="Pending">Pending</option>
                      <option value="Progress">Progress</option>
                      <option value="Completed">Completed</option>
                      <option value="Cancelled">Cancelled</option>
                    </select>
                  </td>
                )}
                {columnVisibility.Feedback && (
                  <td>
                    <select
                      className="table-search background-change"
                      name="Feedback"
                      onChange={handleFilterChange}
                    >
                      <option value="">All</option>
                      <option value="Pending">Pending</option>
                      <option value="Completed">Completed</option>
                    </select>
                  </td>
                )}
                {columnVisibility.AdditionalCharge && (
                  <td>
                    <input
                      className="table-search background-change"
                      name="AdditionalCharge"
                      onChange={handleFilterChange}
                      placeholder="Search"
                    />
                  </td>
                )}
                {columnVisibility.Payment && (
                  <td>
                    <select
                      className="table-search background-change"
                      name="Payment"
                      onChange={handleFilterChange}
                    >
                      <option value="">All</option>
                      <option value="Paid">Paid</option>
                      <option value="Open">Open</option>
                    </select>
                  </td>
                )}
              </tr>
                {Array.isArray(fiterSetting) && fiterSetting.length > 0 ? (

              fiterSetting.map((d, i) => (
                <tr key={i}>
                  {columnVisibility.ComplaintID && (
                    <td
                      onClick={() => {
                        gotoviewcomplaints(d._id);
                      }}
                    >
                      {d.leadId}
                    </td>
                  )}
                  {columnVisibility.ComplaintStatus && (
                    <td>
                      {" "}
                      <span className={getLeadStatusColor(d.leadStatus)}>
                        <span style={{ textTransform: "capitalize" }}>
                          {d.leadStatus}
                        </span>
                      </span>
                    </td>
                  )}
                  {columnVisibility.ComplaintStartDate && (
                    <td>{formatDate(d.createdDate)}</td>
                  )}
                  {columnVisibility.CustomerAffected && (
                    <td>{d.complaintcustomerAffected}</td>
                  )}
                  {columnVisibility.ContactNumber && (
                    <td>{d.complaintcontactNum}</td>
                  )}
                  {columnVisibility.Address && <td>{d.complaintaddress}</td>}
                  {columnVisibility.Location && (
                    <td>
                      {d.location?.latitude
                        ? `${d.location.latitude}, ${d.location.longitude}`
                        : "N/A"}
                    </td>
                  )}
                  {columnVisibility.Notes && (
                    <td>{d.complaintleadStatus.complaintnotes}</td>
                  )}
                  {/* <td>
  <span className={getTabStatusColor(d.verification?.isCompleted ? "Completed" : "Pending")}>
    {d.verification?.isCompleted ? "Completed" : "Pending"}
  </span>
</td> */}
                  {columnVisibility.WorkAssign && (
                    <td>
                      <span
                        className={getTabStatusColor(
                          (() => {
                            const fiberSelected = d.complaintfiber;
                            const networkSelected = d.complaintnetwork;
                            const fiberAssigned = d.workAssign?.fiberTeam?.fiberTeamAssigned === true || d.workAssign?.fiberTeam?.fiberTeamAssigned === "true";
                            const networkAssigned = d.workAssign?.networkTeam?.networkTeamAssigned === true || d.workAssign?.networkTeam?.networkTeamAssigned === "true";

                            if (fiberSelected && networkSelected) return (fiberAssigned && networkAssigned) ? "Assigned" : "Pending";
                            if (fiberSelected) return fiberAssigned ? "Assigned" : "Pending";
                            if (networkSelected) return networkAssigned ? "Assigned" : "Pending";
                            return "Pending";
                          })()
                        )}
                      >
                        {(() => {
                          const fiberSelected = d.complaintfiber;
                          const networkSelected = d.complaintnetwork;
                          const fiberAssigned = d.workAssign?.fiberTeam?.fiberTeamAssigned === true || d.workAssign?.fiberTeam?.fiberTeamAssigned === "true";
                          const networkAssigned = d.workAssign?.networkTeam?.networkTeamAssigned === true || d.workAssign?.networkTeam?.networkTeamAssigned === "true";

                          if (fiberSelected && networkSelected) return (fiberAssigned && networkAssigned) ? "Assigned" : "Pending";
                          if (fiberSelected) return fiberAssigned ? "Assigned" : "Pending";
                          if (networkSelected) return networkAssigned ? "Assigned" : "Pending";
                          return "Pending";
                        })()}
                      </span>
                    </td>
                  )}
                  {columnVisibility.WorkStatus && (
                    <td>
                      <span
                        className={getTabStatusColor(
                          (() => {
                            const fiberSelected = d.complaintfiber;
                            const networkSelected = d.complaintnetwork;
                            const fiberDone = d.workAssign?.fiberTeam?.approvedStatus === "Approved";
                            const networkDone = d.workAssign?.networkTeam?.approvedStatus === "Approved";

                            if (fiberSelected && networkSelected) return (fiberDone && networkDone) ? "Completed" : "Pending";
                            if (fiberSelected) return fiberDone ? "Completed" : "Pending";
                            if (networkSelected) return networkDone ? "Completed" : "Pending";
                            return d.workAssign?.isCompleted ? "Completed" : "Pending";
                          })()
                        )}
                      >
                        {(() => {
                          const fiberSelected = d.complaintfiber;
                          const networkSelected = d.complaintnetwork;
                          const fiberDone = d.workAssign?.fiberTeam?.approvedStatus === "Approved";
                          const networkDone = d.workAssign?.networkTeam?.approvedStatus === "Approved";

                          if (fiberSelected && networkSelected) return (fiberDone && networkDone) ? "Completed" : "Pending";
                          if (fiberSelected) return fiberDone ? "Completed" : "Pending";
                          if (networkSelected) return networkDone ? "Completed" : "Pending";
                          return d.workAssign?.isCompleted ? "Completed" : "Pending";
                        })()}
                      </span>
                    </td>
                  )}
                  {columnVisibility.Feedback && (
                    <td>
                      <span
                        className={getTabStatusColor(
                          d.feedback?.isCompleted ? "Completed" : "Pending"
                        )}
                      >
                        {d.feedback?.isCompleted ? "Completed" : "Pending"}
                      </span>
                    </td>
                  )}
                  {columnVisibility.AdditionalCharge && (
                    <td>{d.complaintadditionalCharges}</td>
                  )}
                  {/* <td>
  <span className={getTabStatusColor(d.payment?.isCompleted ? "Completed" : "Pending")}>
    {d.payment?.isCompleted ? "Completed" : "Pending"}
  </span>
  
</td> */}
                  {columnVisibility.Payment &&
                    (() => {
                      const charge = Number(d.complaintadditionalCharges);
                      const hasCharge = d.complaintadditionalCharges !== undefined &&
                        d.complaintadditionalCharges !== null &&
                        d.complaintadditionalCharges !== "" &&
                        !isNaN(charge) &&
                        charge > 0;

                      if (!hasCharge) {
                        // No additional charges → auto Paid
                        return (
                          <td className="text-center">
                            <span className={getTabStatusColor("Paid")}>Paid</span>
                          </td>
                        );
                      }
                      return (
                        <td>
                          <span
                            className={getTabStatusColor(
                              d.payment?.isCompleted ? "Paid" : "Pending"
                            )}
                          >
                            {d.payment?.isCompleted ? "Paid" : "Pending"}
                          </span>
                        </td>
                      );
                    })()}

                  {columnVisibility.delete && (
                    <td>
                      <button
                        className="deletebtn text-center"
                        onClick={() => handleDelete(d.leadId)}
                      >
                        <MdDelete size={20} />
                      </button>
                    </td>
                  )}
                </tr>
                ))
                ) : (
                  <tr>
                    <td colSpan="16" className="text-center">
                      No data available
                    </td>
                  </tr>
                )}
            </tbody>
          </table>
        </div>
      </Container>
    </div>
  );
}
